module.exports = __webpack_public_path__ + "assets/img/00097.8065942a.png";